import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EpcProjectModel } from '../../../../models/epc-project.model';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EpcService } from '../../../../services/epc.service';
import { ToastrService } from 'ngx-toastr';
import { ThesisOrderModel } from '../../../../models/thesis-order.model';
import { OriginalityService } from '../../../../services/originality.service';

@Component({
  selector: 'thesis-order-mail',
  templateUrl: './thesis-order-mail.html',
  styleUrls: ['./thesis-order-mail.scss'],
})
export class ThesisOrderMail implements OnInit {

  form: FormGroup;

  thesisOrder: ThesisOrderModel = new ThesisOrderModel();

  doAfterEnd: () => void;

  @ViewChild('staticModal', { static: false }) modal: ModalDirective;

  @Output() wasDeleted: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    protected originalityService: OriginalityService,
    protected toastr: ToastrService,
  ) {
  }

  ngOnInit() {
  }

  generateForm() {
    this.form = this.formBuilder.group({
      email: [this.thesisOrder.payerEmail || '', [Validators.required]],
      thesisOrderId: [this.thesisOrder.id || '', [Validators.required]],
    });

  }

  openModal(
    thesisOrder: ThesisOrderModel = null,
    doAfterEnd: () => void = null
  ) {
    if (thesisOrder) {
      this.thesisOrder = thesisOrder;
    }
    this.doAfterEnd = doAfterEnd;
    this.generateForm();
    setTimeout(() => {
      this.modal.show();
    }, 100);
  }

  close(skipAfterEndFn = false) {
    if (this.doAfterEnd && !skipAfterEndFn) {
      this.doAfterEnd();
    }
    this.modal.hide();
  }

  async submitAction() {
    await this.send();
  }

  closeAction() {
    this.close(true);
  }

  async send() {
    if (this.form.invalid) {
      return;
    }

    let res;

    const data = {
      email: this.form.get('email').value,
      thesisOrderId: this.form.get('thesisOrderId').value,
    };

    if (!data.email || !data.thesisOrderId) {
      this.toastr.error('Vyplňte všetky povinné polia.');
      return;
    }

    res = await this.originalityService.sendThesisOrderProtocol(data.thesisOrderId, data.email).toPromise();

    if (!res) {
      console.log(res);
      this.toastr.error('Nastala chyba.');
      return;
    }

    this.toastr.success('E-mail bol úspešne odoslaný.');
    this.close();
  }


}
